import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, SwitchInput } from '../../Form';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { token } from "../../../libs/localStorage";
import { BASE_URL } from "../../../config";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import { autorun, toJS } from "mobx/lib/mobx";
import CronIntervalInput from "../../CronIntervalInput";

@inject('dataExportStore', 'stationStore', 'parameterStore', 'reportingTemplateStore')
@observer
class DataExportAdd extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = `/export/data-export`;
  title = 'Add Data Export';

  locationKeys = {
    '1': {
      'host': 'Host',
      'user_name': 'User Name',
      'user_password': 'User Password',
      'path': 'Path',
      'interval': 'Interval',
    },
    '2': {
      'path': 'Path',
      'interval': 'Interval',
    },
    '3': {
      'path': 'Path ( /data-export )',
    },
  };

  intervalUnits = [
    { name: 'Minute', value: 1 },
    { name: 'Hour', value: 60 },
    { name: 'Day', value: 60 * 24 },
    // {name: 'Month', value: 60 * 24 * 30},
    // {name: 'Year', value: '1'},
  ];

  @observable selectedIntervalUnit = 1;
  @observable selectedOffsetIntervalUnit = 1;
  @observable multiStationOptions = [];
  @observable multiParameterOptions = [];
  @observable dataExport = {
    name: '',
    description: '',
    protocol: '1',
    formatter: '',
    stations: [],
    parameters: [],
    observation_req: '',
    observation_offset: 0,
    use_report_template: 0,
    export_location: {
      host: '',
      user_name: '',
      user_password: '',
      path: '',
      interval: '',
    }
  };

  @observable file = null;

  componentWillMount() {
    const { stationStore, parameterStore } = this.props;
    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();
    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore, parameterStore } = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      if (process.env.NODE_ENV !== 'production') {
        // view hydrology
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, label: item.name, tags: item.tags, value: [28, 78, 238].indexOf(item.id) > -1 }));
        this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, label: item.name, name: item.name, code: item.code, value: [2, 97].indexOf(item.id) > -1 }));

        // // view pollution
        // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, tags: item.tags, value: [11, 107].indexOf(item.id) > -1}));
        // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: [20, 34, 15, 12,3,274,23,24,8,6,31,30,54,105,106].indexOf(item.id) > -1}));
        // this.onView()

        // // view imza
        // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, value: item.name.toLowerCase().indexOf('imza') > -1}));
        // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: [109, 179].indexOf(item.id) > -1}));
        // this.onView()
      } else {
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, label: item.name, value: false, tags: item.tags }));
        this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, label: item.name, name: item.name, code: item.code, value: false }));
      }
    }
  };

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push(item.id);
    return acc;
  }, []);

  @action onChangeObservationReq = e => this.dataExport.observation_req = e.target.value * (+this.selectedIntervalUnit || 1);
  @action onChangeObservationOffset = e => this.dataExport.observation_offset = e.target.value * (+this.selectedOffsetIntervalUnit || 1);
  @action onChangeIntervalUnit = e => {
    if (!e.target.value) this.dataExport.observation_req = 0;
    this.selectedIntervalUnit = e.target.value;
  }
  @action onChangeOffsetIntervalUnit = e => {
    if (!e.target.value) this.dataExport.observation_offset = 0;
    this.selectedOffsetIntervalUnit = e.target.value;
  }
  @action onChangeExport = (e, key) => this.dataExport[key] = e.target.value;
  @action onChangeLocationItem = (e, key) => this.dataExport.export_location[key] = e.target.value;
  @action onChangeUseReportTemplate = () => {
    this.dataExport.use_report_template = ~this.dataExport.use_report_template + 2;
    this.dataExport.formatter = null;
  }

  handleSave = e => {
    e.preventDefault();

    const { notify, router } = this.context;
    const { dataExportStore } = this.props;
    const url = `${BASE_URL}/api/data-delivery/export`;

    const req = request.post(url).set('Authorization', `Bearer ${token.getEncoded()}`);

    this.dataExport.stations = this.optionsReducer(this.multiStationOptions);
    this.dataExport.parameters = this.optionsReducer(this.multiParameterOptions);

    let dataExport = Object.assign({}, toJS(this.dataExport));
    Object.keys(dataExport.export_location).forEach(key => {
      if (Object.keys(this.locationKeys[dataExport.protocol]).indexOf(key) === -1) delete dataExport.export_location[key];
    });


    // console.log(JSON.stringify(this.dataExport));

    req.field('data', JSON.stringify(dataExport))
    if(!!this.file) req.attach('formatter', this.file);

    req.end((err, res) => {
      if (err) {
        console.log(err);
        notify.error(err);
      } else {
        dataExportStore.fetchItems();
        router.push(this.slug);
      }
    })

  };

  onDrop = (files) => {
    this.file = files[0];
  };

  onOpenAddFile = (e) => {
    e.preventDefault();
    this.refs.dropzone.open();
  };

  render() {
    const { dataExportStore, stationStore, parameterStore, reportingTemplateStore } = this.props;
    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataExportStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput
              label={'Name'}
              value={this.dataExport.name}
              onChange={e => this.onChangeExport(e, 'name')}
            />
            <TextInput
              label={'Description'}
              value={this.dataExport.description}
              onChange={e => this.onChangeExport(e, 'description')}
            />
            <SelectInput
              label={'Protocol'}
              value={this.dataExport.protocol}
              options={dataExportStore.protocolOptions}
              fields={{ label: 'name', value: 'id' }}
              onChange={e => this.onChangeExport(e, 'protocol')}
            />
            <SwitchInput label='Use Report Template' value={!!+this.dataExport.use_report_template} onChange={this.onChangeUseReportTemplate} />
            {!!+this.dataExport.use_report_template ?
              <SelectInput label='Report Template' value={this.dataExport.formatter} options={reportingTemplateStore.items} fields={{ label: 'name', value: 'id' }} onChange={e => this.onChangeExport(e, 'formatter')} /> :
              <div className='formInput flex flex-row full-width'>
                <label>Data Formatter</label>
                {/*<button onClick={this.onOpenAddFile}>{!!this.file ? this.file.name :"Choose file"}</button>*/}
                <ReactDropzone ref="dropzone"
                  onDrop={this.onDrop}
                  style={{
                    display: "flex",
                    flexDirection: 'column',
                    justifyContent: 'center',
                    textAlign: "center",
                    height: "35px",
                    minWidth: "310px",
                    cursor: "pointer",
                    border: '1px solid lightgrey'
                  }}>
                  <span style={{ display: "block", color: '#5d5d5d' }} id={"filename"}>
                    {!!this.file ? this.file.name : 'Click or drag a file here to upload!'}
                  </span>
                </ReactDropzone>
              </div>}
            <div className="formInput">
              <label>Observation From</label>
              <input
                type={'text'}
                value={this.dataExport.observation_req ? this.dataExport.observation_req / (this.selectedIntervalUnit || 1) : ''}
                onChange={this.onChangeObservationReq}
                style={{ minWidth: '180px', marginRight: '10px' }}
              />
              <select value={this.selectedIntervalUnit} onChange={this.onChangeIntervalUnit} style={{ width: '100px' }}>
                <option value={''}>--</option>
                {this.intervalUnits.map((option, i) => (
                  <option
                    key={`select-intervalUnit-option-${option.name}-${i}`}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={item => item.value = !item.value} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} style={{ width: '200px' }} />
            <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.multiParameterOptions} optionClicked={item => item.value = !item.value} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} />
          </FormBody>

          <hr />
          <FormBody>
            {Object.keys(this.locationKeys[this.dataExport.protocol.toString()]).map(key => {
              let InputComponent = key === 'interval' ? CronIntervalInput : TextInput;
              return (
                <InputComponent type={key === 'user_password' ? 'password' : 'text'} value={this.dataExport.export_location && this.dataExport.export_location[key]}
                  label={this.locationKeys[this.dataExport.protocol.toString()][key]} onChange={e => this.onChangeLocationItem(e, key)}
                  key={`daq-processor-location-edit-item-key-${key}`} />
              )
            })}
            <div className="formInput">
              <label>Observation Offset</label>
              <input
                type={'text'}
                value={!!+this.dataExport.observation_offset || this.dataExport.observation_offset == 0 ? +this.dataExport.observation_offset / (+this.selectedOffsetIntervalUnit || 1) : ''}
                onChange={this.onChangeObservationOffset}
                style={{ minWidth: '180px', marginRight: '10px' }}
              />
              <select value={this.selectedOffsetIntervalUnit} onChange={this.onChangeOffsetIntervalUnit} style={{ width: '100px' }}>
                <option value={''}>--</option>
                {this.intervalUnits.map((option, i) => (
                  <option
                    key={`select-intervalUnit-option-${option.name}-${i}`}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DataExportAdd;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataExport/DataExportAdd.js